import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function SelectAutoComplete({ options=[], label, value, onChange, required }) {
    return (
      <Autocomplete
        id="tags-outlined"
        options={options}
        getOptionLabel={(option) => (option && option.value) ? option.value : ''}
        value={value}
        onChange={(event, newValue) => onChange(event, newValue)}
        isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
        renderInput={(params) => (
          <TextField
            {...params}
            required={required}
            variant="outlined"
            label={label}
            placeholder={`Selecione`}
          />
        )}
      />
    );
  }
  